import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAppointmentStatusQuickInfo extends Layout {
    labelLabel1: Label;
    panelColorDisplay: Panel;
    panelOrderTypeQuickInfo: Panel;
    sourceAppointmentStatus: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
